import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { GET_COMPANY_DASH_DATA } from "../constants";
import { getUserToken } from "../utilityFunctions/localServices";

export const companyDashboard = createApi({
  reducerPath: "companyDashboard",
  baseQuery: fetchBaseQuery({ baseUrl: GET_COMPANY_DASH_DATA }),
  endpoints: (builder) => ({
    fetchCompanyDashboardData: builder.query({
      query: () => ({
        url: "",
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const { useFetchCompanyDashboardDataQuery } = companyDashboard;
